import type { NextStep } from '../../types/next-steps';

export const getIsStepActive = (steps: NextStep[], currentIndex: number) => {
  const prevStepCompleted = currentIndex > 0 && steps[currentIndex - 1].isCompleted;
  const nextStepCompleted = !!steps[currentIndex + 1] && steps[currentIndex + 1].isCompleted;

  return (
    (currentIndex === 0 && !steps[currentIndex].isCompleted) ||
    (prevStepCompleted && !nextStepCompleted && !steps[currentIndex].isCompleted)
  );
};

export const getActiveStep = (steps: NextStep[]) =>
  steps.find((_, index) => getIsStepActive(steps, index));
